import { ReactComponent as Rss } from 'assets/icons/icon-rss.svg';

export default Rss;
